<template>
    <div class="container">
      <el-carousel
        trigger="click"
        arrow="never"
        height="370px"
      >
        <el-carousel-item>
          <div class="content-row">
            <div class="row-left">
              <div class="img-wrap">
                <img
                  src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/mobile/programme_img1.png"
                  alt=""
                />
              </div>
            </div>
            <div class="row-right">
              <div class="block-text">
                <div class="title">实时监控</div>
                <div class="desc">
                    提供无人机巡逻区域的实时视图，支持实时数据分析和决策。
                </div>
              </div>
            </div>
          </div>
        </el-carousel-item>
  
        <el-carousel-item>
          <div class="content-row">
            <div class="row-left">
              <div class="img-wrap">
                <img
                  src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/mobile/programme_img2.png"
                  alt=""
                />
              </div>
            </div>
            <div class="row-right">
              <div class="block-text">
                <div class="title">集中控制</div>
                <div class="desc">
                    通过控制台集中管理所有无人机的飞行任务和数据流，实现对全辖区巡逻任务的实时调度。 
                </div>
              </div>
            </div>
          </div>
        </el-carousel-item>
  
        <el-carousel-item>
          <div class="content-row">
            <div class="row-left">
              <div class="img-wrap">
                <img
                  src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/mobile/programme_img3.png"
                  alt=""
                />
              </div>
            </div>
            <div class="row-right">
              <div class="block-text">
                <div class="title">AI智能识别分析</div>
                <div class="desc">
                    集成深度学习算法，能够识别违规行为、非法建筑和异常活动等。
                </div>
              </div>
            </div>
          </div>
        </el-carousel-item>
  
        <el-carousel-item>
          <div class="content-row">
            <div class="row-left">
              <div class="img-wrap">
                <img
                  src="https://dronecloud-files.s3.cn-northwest-1.amazonaws.com.cn/wxapp/static/images/guanwang/images/mobile/programme_img4.png"
                  alt=""
                />
              </div>
            </div>
            <div class="row-right">
              <div class="block-text">
                <div class="title">与执法系统对接</div>
                <div class="desc">
                    将无人机获取的数据与卫星图斑核查、日常巡查等业务系统进行整合，实现数据共享和业务协同。
                </div>
              </div>
            </div>
          </div>
        </el-carousel-item>
      </el-carousel>
    </div>
  </template>
  
  <script>
  export default {
    data() {
      return {};
    },
  };
  </script>
  
  <style lang="stylus" scoped>
  /deep/.el-carousel__button {
      background-color: #E0E0E0;
  }
  /deep/.el-carousel__indicator.is-active button {
      background-color:#2372E9;
  }
  /deep/.el-carousel__indicators--horizontal {
      width:270px !important;
      display:flex;
      justify-content:center;
    }
    .content-row {
              display:flex;
              flex-direction: column;
              margin-bottom:4rem;
              >div {
                  flex:1;
              }
              .img-wrap {
                  display:flex;
                  justify-content: center;
                  align-items: center;
              }
              .row-left {
                  .img-wrap {
                      max-height:314px !important;
                      overflow:hidden;
                      display:flex;
                      justify-content: center;
                      align-items: center;
                  }
                  img {
                      width:100%;
                  }
              }
              .block-text {
                  padding:17px 0 10px;
                  .title {
                      color:#2372E9;
                      margin-bottom:10px;
                      font-size:18px;
                  }
                  .desc {
                      color:#333333;
                      line-height:30px;
                      font-size:14px;
                      line-height:20px !important;
                  }
              }
          }
  </style>
  